/**
 * Urgency utility — shared 3-color pattern for all timed windows.
 * cyan-green (safe) → gold (warning) → red (critical, pulsing).
 */

import { URGENCY } from '../constants';

/** Get urgency color based on remaining time fraction (1.0 = full, 0.0 = depleted). */
export function getUrgencyColor(fraction: number): number {
  if (fraction > URGENCY.WARN_THRESHOLD) return URGENCY.SAFE_COLOR;
  if (fraction > URGENCY.CRITICAL_THRESHOLD) return URGENCY.WARN_COLOR;
  return URGENCY.CRITICAL_COLOR;
}

/** Get urgency alpha pulse (1.0 = steady, oscillates when critical). */
export function getUrgencyPulse(fraction: number, time: number): number {
  if (fraction > URGENCY.CRITICAL_THRESHOLD) return 1.0;
  const speed = 4 + (1 - fraction / URGENCY.CRITICAL_THRESHOLD) * 8;
  return 0.6 + 0.4 * Math.sin(time * speed);
}
